// Lekka warstwa offline dla aplikacji montera:
// - cache listy zleceń i szczegółów (odczyt bez sieci)
// - kolejka zapisu (status, postęp spawów) z synchronizacją po odzyskaniu łącza.
const TASKS_KEY = "fp_offline_tasks";
const OUTBOX_KEY = "fp_offline_outbox";
const TASK_PREFIX = "fp_offline_task_";

export function cacheTasks(list) {
  try { localStorage.setItem(TASKS_KEY, JSON.stringify(list || [])); } catch (e) { /* ignore */ }
}
export function getCachedTasks() {
  try { return JSON.parse(localStorage.getItem(TASKS_KEY) || "[]"); } catch (e) { return []; }
}
export function cacheTask(t) {
  if (!t || !t.id) return;
  try { localStorage.setItem(TASK_PREFIX + t.id, JSON.stringify(t)); } catch (e) { /* ignore */ }
}
export function getCachedTask(id) {
  try { return JSON.parse(localStorage.getItem(TASK_PREFIX + id) || "null"); } catch (e) { return null; }
}
export function getOutbox() {
  try { return JSON.parse(localStorage.getItem(OUTBOX_KEY) || "[]"); } catch (e) { return []; }
}
function setOutbox(x) {
  try { localStorage.setItem(OUTBOX_KEY, JSON.stringify(x)); } catch (e) { /* ignore */ }
}
export function enqueue(item) {
  const x = getOutbox();
  x.push({ ...item, ts: Date.now() });
  setOutbox(x);
}
export function outboxSize() { return getOutbox().length; }
export function isNetworkError(e) { return !e || !e.response; }

// Odtwarza zakolejkowane żądania POST. Zwraca liczbę zsynchronizowanych.
// Wpisy z odpowiedzią serwera (nawet błędną) uznaje za dostarczone; przy braku sieci zostawia w kolejce.
export async function flushOutbox(api) {
  const x = getOutbox();
  if (!x.length) return 0;
  const remaining = [];
  let done = 0;
  for (const it of x) {
    try { await api.post(it.url, it.body || {}); done++; }
    catch (e) { if (e && e.response) { done++; } else { remaining.push(it); } }
  }
  setOutbox(remaining);
  return done;
}
